<template>
  <div class="mx-auto my-2">
    <v-card class="mx-4" flat>
      <v-card-title>
        Trainee Report
        <v-spacer></v-spacer>

        <div class="ml-12">
          <download-excel
 v-if="$can('trainee-report', 'export')"              :data="selected"
              :fields="export_fields"
              name="trineeReport.xls"
              type="csv"
          >
            <v-btn
                class="teal white--text"
                color="primary"
                dark
                depressed
                small
            >
              <v-icon left>mdi-export</v-icon>
              <span>Export</span>
            </v-btn>
          </download-excel>
        </div>
      </v-card-title>

      <v-data-table
          v-model="selected"
          :headers="headers"
          :items="traineeReport.rows"
          :loading="loading"
          :options.sync="options"
          :server-items-length="traineeReport.count"
          class="elevation-1"
          loading-text="Loading... please wait"
          show-select
      >

        <template v-slot:top>
          <v-layout class="p-2" row wrap>
            <v-flex class="p-2" xs2>
              <v-text-field
                  v-model="nameValue"
                  label="Name"
                  type="text"
              ></v-text-field>
            </v-flex>
            <v-flex class="p-2" xs2>
              <v-text-field
                  v-model="phoneValue"
                  label="Phone Number"
                  type="number"
              ></v-text-field>
            </v-flex>
            <v-flex class="p-2" xs2>
              <v-text-field
                  v-model="licenseNumberValue"
                  label="License Number"
                  type="number"
              ></v-text-field>
            </v-flex>
            <v-flex class="p-2" xs2>
              <v-text-field
                  v-model="nationalIdValue"
                  label="National Id"
                  type="text"
              ></v-text-field>
            </v-flex>
            <v-flex class="p-2" xs2>
              <v-text-field
                  v-model="employeeIdValue"
                  label="Employee Id"
                  type="text"
              ></v-text-field>
            </v-flex>
            <v-flex class="p-2" xs2>
              <v-select
                  v-model="dateRangePreset"
                  :items="dateRangePresets"
                  item-text="text"
                  item-value="value"
                  clearable
                  label="Quick Range"
              ></v-select>
            </v-flex>
            <v-flex class="p-2" xs2>
              <v-select
                  v-model="dateRangeYear"
                  :items="dateRangeYears"
                  clearable
                  label="Year"
              ></v-select>
            </v-flex>
            <v-flex v-if="dateRangePreset && dateRangePreset !== 'yearly'" class="p-2" xs2>
              <v-select
                  v-model="dateRangePeriod"
                  :items="getPresetPeriodOptions(dateRangePreset)"
                  :disabled="!dateRangePreset || dateRangePreset === 'yearly'"
                  clearable
                  label="Period"
              ></v-select>
            </v-flex>
            <v-flex class="p-2" xs2>
              <v-menu
                  ref="startMenu"
                  v-model="startMenu"
                  :close-on-content-click="false"
                  max-width="290px"
                  min-width="290px"
                  offset-y
                  transition="scale-transition"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="startDateValue"
                      :clearable="true"
                      persistent-hint
                      placeholder="Start Date"
                      prepend-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                    v-model="startDateValue"
                    no-title
                    scrollable
                    @input="startMenu = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex class="p-2" xs2>
              <v-menu
                  ref="endMenu"
                  v-model="endMenu"
                  :close-on-content-click="false"
                  max-width="290px"
                  min-width="290px"
                  offset-y
                  transition="scale-transition"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="endDateValue"
                      :clearable="true"
                      persistent-hint
                      placeholder="End Date"
                      prepend-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                    v-model="endDateValue"
                    no-title
                    scrollable
                    @input="endMenu = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-switch v-model="isEmployeeValue" :label="
        `${isEmployeeValue == true
          ? 'Employee'
          : 'Non-Employee'
        }`
      " class="black--text"></v-switch>
          </v-layout>
        </template>

        <template v-slot:[`item.firstName`]="{ item }">
          <label for="item">{{ item.firstName }} {{ item.middleName }} {{ item.lastName }}</label>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import {TraineeReportService} from "./trainee-report-service";
import reportDateRangeMixin from "@/mixins/reportDateRangeMixin";

export default {
  mixins: [reportDateRangeMixin],
  data() {
    return {
      search: "",
      options: {
        page: 1,
        itemsPerPage: 10,
      },
      traineeReport: [],
      export_fields: {
        "First Name": "firstName",
        "Middle Name": "middleName",
        "Last Name": "lastName",
        "Gender": "gender",
        "Phone": "phoneNumber",
        "License Number": "licenseNumber",
        "National Id": "national_id",
        "Employee Id": "employeeId",
        "Facility Email": "facilityEmail",
        "Facility": "facility.name",
        "Region": "region",
        "ZONE": "zone",
      },
      headers: [
        {text: "Full Name", value: `firstName`},
        {text: "Gender", value: "gender"},
        {text: "Phone", value: "phoneNumber"},
        {text: "License Number", value: "licenseNumber"},
        {text: "National Id", value: "national_id"},
        {text: "Employee Id", value: "employeeId"},
        {text: "Facility Email", value: "facilityEmail"},
        {text:"Facility", value: "facility.name"},
        {text: "Region", value: "region"},
        {text: "ZONE", value: "zone"},
      ],
      loading: false,
      clearable: true,
      selected: [],
      EXPERT_LEVEL: [],
      expertLevelValue: null,

      nameValue: null,
      phoneValue: null,
      licenseNumberValue: null,
      nationalIdValue: null,
      employeeIdValue: null,
      isEmployeeValue: null,
      startDateValue: null,
      endDateValue: null,
      startMenu: false,
      endMenu: false,
      dateRangePreset: null,
      dateRangeYear: null,
      dateRangePeriod: null,
    };
  },
  async beforeMount() {
    this.fetchTraineeReport();
  },
  watch: {
    options: {
      handler() {
        this.fetchTraineeReport();
      },
      deep: true,
    },
    nameValue: function (val) {
      this.nameValue = val;
      this.fetchTraineeReport();
    },
    phoneValue: function (val) {
      this.phoneValue = val;
      this.fetchTraineeReport();
    },
    licenseNumberValue: function (val) {
      this.licenseNumberValue = val;
      this.fetchTraineeReport();
    },
    nationalIdValue: function (val) {
      this.nationalIdValue = val;
      this.fetchTraineeReport();
    },
    employeeIdValue: function (val) {
      this.employeeIdValue = val;
      this.fetchTraineeReport();
    },
    isEmployeeValue: function (val) {
      this.isEmployeeValue = val;
      this.fetchTraineeReport();
    },
    startDateValue: function (val) {
      this.startDateValue = val == '' ? null : val;
      this.fetchTraineeReport();
    },
    endDateValue: function (val) {
      this.endDateValue = val == '' ? null : val;
      this.fetchTraineeReport();
    },
    dateRangePreset: function (val) {
      this.applyPresetWithSelection(val, "startDateValue", "endDateValue", "dateRangeYear", "dateRangePeriod");
    },
    dateRangeYear: function () {
      if (this.dateRangePreset) {
        this.applyPresetWithSelection(this.dateRangePreset, "startDateValue", "endDateValue", "dateRangeYear", "dateRangePeriod");
      }
    },
    dateRangePeriod: function () {
      if (this.dateRangePreset) {
        this.applyPresetWithSelection(this.dateRangePreset, "startDateValue", "endDateValue", "dateRangeYear", "dateRangePeriod");
      }
    },
  },
  computed: {},
  methods: {
    async fetchTraineeReport() {
      this.loading = true;
      const {page, itemsPerPage} = this.options;
      let searchParams = '?';
      itemsPerPage > 0 && (searchParams += `page=${page}&pageSize=${itemsPerPage}`);

      this.nameValue !== null && (searchParams += '&name=' + this.nameValue);
      this.phoneValue !== null && (searchParams += '&phone=' + this.phoneValue);
      this.licenseNumberValue !== null && (searchParams += '&licenseNumber=' + this.licenseNumberValue);
      this.nationalIdValue !== null && (searchParams += '&nationalId=' + this.nationalIdValue);
      this.employeeIdValue !== null && (searchParams += '&employeeId=' + this.employeeIdValue);
      this.isEmployeeValue !== null && (searchParams += '&isEmployed=' + this.isEmployeeValue);
      this.startDateValue !== null && (searchParams += '&startDate=' + this.startDateValue);
      this.endDateValue !== null && (searchParams += '&endDate=' + this.endDateValue);

      const res = await TraineeReportService.getTraineeReports(searchParams);
      if (res.status === 200) {
        this.loading = false;
        this.traineeReport = res.data;
      } else {
        this.loading = false;
        this.$toast.error(
            "There was a problem fetching Trainee reports, Please try Again!"
        );
      }
    },
  },
};

</script>

<style scoped>
.addCard {
  background: hsla(0, 0%, 100%, 0.45);
}
</style>
